import axios from "axios";
var viaCepBaseUrl = "/api/viacep/ws";
var ibgeBaseUrl = "/api/ibge-localidades/api/v1";
var apiJepisBaseUrl = "/api/jepis/jepis/api/v1";
export var ibgeApi = axios.create({ baseURL: ibgeBaseUrl });
export var viaCepApi = axios.create({ baseURL: viaCepBaseUrl });
export var jepisApi = axios.create({
    baseURL: apiJepisBaseUrl,
    headers: {
        "X-API-KEY": process.env.JEPIS_API_KEY,
    },
});
